module.exports = __webpack_public_path__ + "img/touming1.03ee9cf8.png";